import { IHeaderCell, Order } from "./TableHeader";
import moment, { Moment } from "moment";

function desc<TModel>(a: TModel, b: TModel, orderBy: IHeaderCell<TModel>) {
  const aProp = a[orderBy.propName];
  const bProp = b[orderBy.propName];

  if (orderBy.date) {
    let aDate: Moment = moment(aProp);
    let bDate: Moment = moment(bProp);

    if (bDate.isBefore(aDate)) {
      return -1;
    }
    if (aDate.isBefore(bDate)) {
      return 1;
    }
    return 0;
  }

  if (typeof aProp === "string" && typeof bProp === "string") {
    let aStr = aProp.toLowerCase();
    let bStr = bProp.toLowerCase();
    if (bStr < aStr) {
      return -1;
    }
    if (bStr > aStr) {
      return 1;
    }
    return 0;
  }

  if (bProp < aProp) {
    return -1;
  }
  if (bProp > aProp) {
    return 1;
  }
  return 0;
}

function getSorting<TModel>(orderBy: IHeaderCell<TModel>): (a: TModel, b: TModel) => number {
  return orderBy.order === "desc" ? (a, b) => desc<TModel>(a, b, orderBy) : (a, b) => -desc<TModel>(a, b, orderBy);
}

interface ISortable<TModel> {
  model: TModel;
  originalOrder: number;
}

export function sortRows<TModel>(array: TModel[], orderBy?: IHeaderCell<TModel>) {
  const rows: Array<ISortable<TModel>> = array.map((item, index) => ({
    model: item,
    originalOrder: index,
  }));

  let compare: any;
  if (orderBy) {
    compare = getSorting<TModel>(orderBy);
  }

  rows.sort((x, y) => {
    if (compare) {
      return compare(x.model, y.model);
    }
    // return original sort order
    return x.originalOrder - y.originalOrder;
  });

  return rows.map(item => item.model);
}

export function updateSorts<TModel>(cells: Array<IHeaderCell<TModel>>, orderBy: IHeaderCell<TModel>): Array<IHeaderCell<TModel>> {
  return cells.map(c => {
    let order: Order | undefined;
    if (orderBy.propName === c.propName) {
      if (c.order === "asc") {
        order = "desc";
      } else {
        order = "asc";
      }
    }
    return { ...c, order: order } as IHeaderCell<TModel>;
  });
}

export function getCurrentOrderBy<TModel>(cells: Array<IHeaderCell<TModel>>): IHeaderCell<TModel> | undefined {
  let filtered = cells.filter(c => c.order);
  return filtered.length ? filtered[0] : undefined;
}
